import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "w-[18px] px-[3px] py-2 flex-col justify-center items-center gap-2.5 inline-flex" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "w-[18px] h-[18px] p-[3px] justify-center items-center flex" }
const _hoisted_6 = { class: "w-3 h-3 relative" }
const _hoisted_7 = {
  key: 1,
  class: "md:w-[390px]"
}
const _hoisted_8 = { class: "grid grid-cols-2 text-racq-med-grey text-sm font-body" }
const _hoisted_9 = { class: "text-right" }

import { ISitecoreFormGenericInput } from '@/interfaces';
import { toBool } from '@/utils/convert';
import { FormKit } from '@formkit/vue';
import { Field } from '@sitecore-jss/sitecore-jss-vue';
import { onBeforeUnmount, onMounted, ref, watch, computed } from 'vue';

interface Props extends ISitecoreFormGenericInput {
  hideStepper: Field<boolean>;
  hideSlider: Field<boolean>;
  hideButtons?: Field<boolean>;
  stepperType: Field<string>;
  stepperUnit: Field<string>;
  stepperStep: Field<number>;
  currencyDecimal?: Field<number>;
  min: Field<number>;
  max: Field<number>;
  minLabel?: Field<string>;
  maxLabel?: Field<string>;
  validationRegexErrorMessage?: Field<string>;
}

/** Local state and data properties*/

export default /*@__PURE__*/_defineComponent({
  __name: 'RangeInput',
  props: /*@__PURE__*/_mergeModels({
    hideStepper: {},
    hideSlider: {},
    hideButtons: {},
    stepperType: {},
    stepperUnit: {},
    stepperStep: {},
    currencyDecimal: {},
    min: {},
    max: {},
    minLabel: {},
    maxLabel: {},
    validationRegexErrorMessage: {},
    id: {},
    name: {},
    label: {},
    formInputId: {},
    inputType: {},
    placeholderText: {},
    postContent: {},
    preContent: {},
    postContentClass: {},
    preContentClass: {},
    tooltipContent: {},
    tooltipModalTitle: {},
    tooltipShowInModal: {},
    fields: {},
    emptyMessage: {},
    validation: {},
    outerClass: {},
    innerClass: {},
    refData: {},
    prefixIcon: {},
    suffixIcon: {},
    helpXs: {},
    helpSm: {},
    helpMd: {},
    disablePaste: {},
    classesOptions: {},
    showClearIcon: {},
    autocomplete: {},
    options: {},
    optionsClass: {},
    defaultOption: {},
    inputInnerClass: {},
    isRequired: {},
    isRequiredErrorMessage: {},
    validationRegex: {},
    mustAccept: {},
    mustAcceptErrorMessage: {},
    mask: {},
    isHidden: { type: Boolean },
    showPostContent: { type: Boolean },
    dynamicOptions: {},
    elementId: {},
    titleRequiredMessage: {},
    firstnameRequiredErrorMessage: {},
    firstnameRegex: {},
    firstnameRegexErrorMessage: {},
    lastnameRequiredErrorMessage: {},
    lastnameRegex: {},
    lastnameRegexErrorMessage: {},
    format: {},
    pickerOnly: {},
    minDateToday: {},
    maxDateByDays: {},
    icon: {},
    title: {},
    subTitle: {},
    decimals: {},
    minDecimals: {},
    noDecimalsErrorMessage: {},
    minlength: {},
    maxlength: {},
    promoCards: {},
    heading: {},
    cardLayout: {},
    maxItemsToShow: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const value = _useModel<number>(__props, "modelValue");
const stepperValue = ref<number>();
const sliderValue = ref<number>();
const props = __props;
const stepperEl = ref<any>();
const sliderEl = ref<any>();
const loaded = ref(false);
const isDragging = ref(false);
const editingStepper = ref(false);

/** Computed Properties */
const validation = computed(() => {
  let v = `min:${props.min.value}|max:${props.max.value}`;
  if (toBool(props.isRequired?.value)) {
    v += '|required';
  }
  return v;
});

const validationMessage = computed(() => {
  try {
    return JSON.parse(props.validationRegexErrorMessage?.value ?? '{}');
  } catch {
    return {};
  }
});

/** Functions */
function calculate(step: number) {
  const req = Number(value.value || props.min.value) + step;
  if (req > props.max.value) {
    value.value = props.max.value;
  } else if (req < props.min.value) {
    value.value = props.min.value;
  } else {
    value.value = req;
  }
}

function updateValue(el: any) {
  let newVal = Number(el.node.value);
  editingStepper.value = false;
  setValue(newVal);
}

function setValue(newVal: number) {
  if (Number.isNaN(newVal) || newVal < props.min.value || newVal > props.max.value) {
    return;
  }
  stepperValue.value = sliderValue.value = value.value = newVal;
}

/** Lifecycle Hooks */
watch(value, (newVal) => {
  if (stepperValue.value != newVal) stepperValue.value = newVal;
  if (sliderValue.value != newVal) sliderValue.value = newVal;
  if (stepperValue.value && !loaded.value) loaded.value = true;
});

watch(sliderValue, (newValue) => {
  if (!isDragging.value) value.value = newValue;
  stepperValue.value = newValue;
});

const mouseupListener = () => {
  if (isDragging.value) {
    isDragging.value = false;
    updateValue(sliderEl.value);
  }
};

onMounted(() => {
  value.value && setValue(value.value);
  document.addEventListener('mouseup', mouseupListener);
  document.addEventListener('touchend', mouseupListener);
});

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', mouseupListener);
  document.removeEventListener('touchend', mouseupListener);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid gap-6", _ctx.outerClass?.value])
  }, [
    (!_ctx.hideStepper.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.hideButtons?.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "h-10 !min-w-0 w-[42px] btn btn-md btn-secondary !px-3",
                type: "button",
                disabled: value.value == _ctx.min.value,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (calculate(-1 * _ctx.stepperStep.value)))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: _normalizeClass(`w-2.5 h-0.5 rounded border border-racq-blue ${value.value == _ctx.min.value ? 'bg-racq-form-border' : 'bg-racq-blue'}`)
                  }, null, 2)
                ])
              ], 8, _hoisted_2))
            : _createCommentVNode("", true),
          (loaded.value)
            ? (_openBlock(), _createBlock(_unref(FormKit), {
                key: 1,
                ref_key: "stepperEl",
                ref: stepperEl,
                modelValue: stepperValue.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stepperValue).value = $event)),
                value: stepperValue.value,
                outerClass: "md:racq-w-sm w-full",
                name: _ctx.name + 'stepper',
                type: _ctx.stepperType?.value ?? 'number',
                valueFormat: "number",
                unit: _ctx.stepperUnit?.value,
                decimals: _ctx.currencyDecimal?.value ?? 0,
                validation: validation.value,
                validationMessages: validationMessage.value,
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (editingStepper.value = true)),
                onBlur: _cache[3] || (_cache[3] = () => updateValue(stepperEl.value)),
                onKeyup: _cache[4] || (_cache[4] = _withKeys(() => updateValue(stepperEl.value), ["enter"]))
              }, null, 8, ["modelValue", "value", "name", "type", "unit", "decimals", "validation", "validationMessages"]))
            : _createCommentVNode("", true),
          (!_ctx.hideButtons?.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "h-10 !min-w-0 w-[42px] btn btn-md btn-secondary !px-3",
                type: "button",
                disabled: value.value == _ctx.max.value,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (calculate(_ctx.stepperStep.value)))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`w-3 h-0.5 left-0 top-[5px] absolute rounded border border-racq-blue ${value.value == _ctx.max.value ? 'bg-racq-form-border' : 'bg-racq-blue'}`)
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(`w-3 h-0.5 left-[5px] top-3 absolute origin-top-left -rotate-90 rounded border border-racq-blue ${value.value == _ctx.max.value ? 'bg-racq-form-border' : 'bg-racq-blue'}`)
                    }, null, 2)
                  ])
                ])
              ], 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hideSlider.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(FormKit), {
            ref_key: "sliderEl",
            ref: sliderEl,
            modelValue: sliderValue.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((sliderValue).value = $event)),
            type: "slider",
            outerClass: "md:w-[390px] w-full",
            min: _ctx.min.value,
            max: _ctx.max.value,
            name: _ctx.name + 'slider'
          }, {
            handleMaxInner: _withCtx(() => [
              _createElementVNode("div", {
                class: "w-full h-full",
                onMousedown: _cache[6] || (_cache[6] = ($event: any) => (isDragging.value = true)),
                onTouchstart: _cache[7] || (_cache[7] = ($event: any) => (isDragging.value = true))
              }, null, 32)
            ]),
            _: 1
          }, 8, ["modelValue", "min", "max", "name"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_ctx.minLabel?.value || _ctx.min.value), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.maxLabel?.value || _ctx.max.value), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(FormKit), {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((value).value = $event)),
      type: "hidden",
      name: _ctx.name
    }, null, 8, ["modelValue", "name"])
  ], 2))
}
}

})